/**
 * ConstructionProposalPage — full-page route wrapper.
 *   /admin/proposals/construction/new
 *   /admin/proposals/construction/:id
 */
import { useParams } from "react-router-dom";
import { useAuth } from "@/App";
import ConstructionProposalBuilder from "@/components/admin/ConstructionProposalBuilder";

export default function ConstructionProposalPage() {
  const { id } = useParams();
  const { token } = useAuth();
  return <ConstructionProposalBuilder proposalId={id} token={token} />;
}
